import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import AboutUsContent from "../ones/AboutUsContent";
import HomeBanner3 from "../ones/HomeBanner3";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<AboutUsContent/>
				<HomeBanner3/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}